import { render, staticRenderFns } from "./ProductRequest.vue?vue&type=template&id=dbb19c58&scoped=true&"
import script from "./ProductRequest.vue?vue&type=script&lang=js&"
export * from "./ProductRequest.vue?vue&type=script&lang=js&"
import style0 from "./ProductRequest.vue?vue&type=style&index=0&id=dbb19c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb19c58",
  null
  
)

export default component.exports